module.exports = __webpack_public_path__ + "img/maria-en.49787fae.png";